import { CommonEnums } from '../../../common.enums';
import { FileTransfer_Inst } from '../../domain/file_transfer_inst'
import { Conn_Db_Obj_Lnk } from '../../conn_Db_Obj_Lnk';
import { DxFlow_Obj_Property } from '../../domain/dxflow_obj_property'
import { Conn_Db_Obj_LnksUtil } from 'src/app/shared/utils/conn_db_obj_lnks.util';
import { DxFlow_Obj_PropertiesUtil } from 'src/app/shared/utils/dxflow_obj_properties.util';

export class FileTransfer {
    fileTransfer_Inst: FileTransfer_Inst;
    conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>;
    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.fileTransfer_Inst = new FileTransfer_Inst();
        this.conn_Db_Obj_Lnks = new Array<Conn_Db_Obj_Lnk>();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();
        this.change_Ind = CommonEnums.defaults.STRING_EMPTY;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
    }

    static parse(fileTransferTmp: FileTransfer): FileTransfer {
        let fileTransfer: FileTransfer = new FileTransfer();
        fileTransfer.copyFrom(fileTransferTmp);
        return fileTransfer;
    }

    copy(): FileTransfer {
        let fileTransferTmp: FileTransfer = new FileTransfer();

        fileTransferTmp.fileTransfer_Inst = this.fileTransfer_Inst.copy();
        fileTransferTmp.conn_Db_Obj_Lnks = Conn_Db_Obj_LnksUtil.getInstance().copy(this.conn_Db_Obj_Lnks);
        fileTransferTmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);
        fileTransferTmp.change_Ind = this.change_Ind;
        fileTransferTmp.error_Cd = this.error_Cd;
        fileTransferTmp.error_Msg = this.error_Msg;
        fileTransferTmp.ref_Cd = this.ref_Cd;
        fileTransferTmp.ref_Id = this.ref_Id;
        fileTransferTmp.fldr_Id = this.fldr_Id;

        return fileTransferTmp;
    }

    copyFrom(fileTransferTmp: FileTransfer): void {
        this.fileTransfer_Inst.copyFrom(fileTransferTmp.fileTransfer_Inst);
        Conn_Db_Obj_LnksUtil.getInstance().copyFrom(this.conn_Db_Obj_Lnks, fileTransferTmp.conn_Db_Obj_Lnks);
        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, fileTransferTmp.dxFlow_Obj_Properties);
        this.change_Ind = fileTransferTmp.change_Ind;
        this.error_Cd = fileTransferTmp.error_Cd;
        this.error_Msg = fileTransferTmp.error_Msg;
        this.ref_Id = fileTransferTmp.ref_Id;
        this.ref_Cd = fileTransferTmp.ref_Cd;
        this.fldr_Id = fileTransferTmp.fldr_Id;
    }

    compare(fileTransferTmp: FileTransfer): string {
        let diffString ='';
         diffString =(this.fileTransfer_Inst).compare(fileTransferTmp.fileTransfer_Inst);
        if (diffString != '') return diffString;

        diffString = Conn_Db_Obj_LnksUtil.getInstance().compare(this.conn_Db_Obj_Lnks, fileTransferTmp.conn_Db_Obj_Lnks);
        if (diffString != '') return diffString;

        return diffString;
    }

    tostring(isNotCompare: boolean = true): string {
        let str: string = "FileTransfer [fileTransfer_Inst=" + this.fileTransfer_Inst.toString() +
            ", conn_Db_Obj_Lnks=" + Conn_Db_Obj_LnksUtil.getInstance().toString(this.conn_Db_Obj_Lnks) +
            ", dxFlow_Obj_Properties=" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties);

        if (isNotCompare) {
            str += ", change_Ind=" + this.change_Ind + ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
                ", ref_Cd=" + this.ref_Cd + ", ref_Id=" + this.ref_Id + ", fldr_Id=" + this.fldr_Id;
        }

        str += "]";
        return str;
    }
}